// extracted by mini-css-extract-plugin
module.exports = {"htmlContent":"HtmlContent_htmlContent__8S08u"};